import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Icon, Image } from 'semantic-ui-react';
import { CardInfo } from '../../Api/types';
import styles from './UserCard.module.css';

export interface UserCardProps {
    card: CardInfo;
}

function UserCard(props: UserCardProps) {
    const card = props.card;

    return (
        <>
            <Card className={styles['card']} color={card.status === 'active' ? null : 'red'}>
                <Image src={'/api/user/card/qr?link=' + card.link} wrapped ui={false} />
                <Card.Content>
                    <Card.Header>{card.name}</Card.Header>
                    <Card.Meta>
                        <span>№{card.number}</span>
                    </Card.Meta>
                </Card.Content>
                <Card.Content extra>
                    <Icon name='ruble' />
                    {card.balance} бнс.
                </Card.Content>
                <Card.Content extra>
                    <Button.Group fluid vertical>
                        <Button as={Link} to={card.link} basic color='teal'>Скачать</Button>
                        <Button as={Link} to={'/card/' + card.uuid} basic color='yellow'>Анкета</Button>
                    </Button.Group>
                </Card.Content>
            </Card>
        </>
    );
}

export default UserCard;